"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var Loading = function Loading() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    className: "loading",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Loader, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "first"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "second"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "third"
      })]
    })
  });
};

exports.Loading = Loading;